module.exports = __webpack_public_path__ + "img/lock-screen.286c6987.png";